
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexGjN753o1ViwdkO9lT0j6mT23A5OIxtP9A8ozvL3X7vAMeta } from "/Users/bdotzour/Development/thorne-site-nuxt/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93uwJ1o5Fcp8vP06vlyY3CffwPGxiZQVxFYxQoZwHI0vsMeta } from "/Users/bdotzour/Development/thorne-site-nuxt/src/pages/[...slug].vue?macro=true";
import { default as reviewsARzk4Uno43CNtTgKKvHtG796KZtK0NWZp91GMAdddmgMeta } from "/Users/bdotzour/Development/thorne-site-nuxt/src/pages/products/reviews.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/bdotzour/Development/thorne-site-nuxt/src/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/Users/bdotzour/Development/thorne-site-nuxt/src/pages/[...slug].vue")
  },
  {
    name: "products-reviews",
    path: "/products/reviews",
    component: () => import("/Users/bdotzour/Development/thorne-site-nuxt/src/pages/products/reviews.vue")
  }
]